import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5987b3d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  style: {
    "margin-bottom": "10px",
    "display": "flex",
    "justify-content": "flex-end"
  }
};
const _hoisted_3 = {
  key: 0,
  style: {
    "margin": "10px",
    "display": "flex",
    "justify-content": "flex-end"
  }
};
import { onMounted, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import MaterialDialog from './components/MaterialDialog.vue';
import MaterialCategory from './components/MaterialCategory.vue';
import { getMaterialPageList, deleteMaterial, getMaterialDetail } from '@/api/material';
import { useRouter } from 'vue-router';
const pageSize = 10; // 一页数量

export default {
  __name: 'index',
  setup(__props) {
    const data = ref([]);
    const loading = ref(false);
    const currentPage = ref(1); // 当前页数
    const total = ref(0);
    const categoryId = ref('');
    const title = ref('');
    /**
     * 获取appid列表
     */
    const loadData = async () => {
      loading.value = true;
      try {
        const res = await getMaterialPageList({
          currentPage: currentPage.value,
          pageSize: 10,
          categoryId: categoryId.value,
          title: title.value
        });
        data.value = res.records;
        total.value = res.total;
      } catch (error) {} finally {
        loading.value = false;
      }
    };
    const handleChangeCategory = e => {
      categoryId.value = e;
      loadData();
    };
    onMounted(() => {
      loadData();
    });

    // 页数切换
    const handleCurrentChange = page => {
      currentPage.value = page;
      loadData();
    };
    // 添加appid-
    const addGmVisible = ref(false);
    const onAddMaterial = () => {
      currentId.value = null;
      addGmVisible.value = true;
    };
    // 编辑当前appid
    const currentId = ref(null);
    const editMaterial = async row => {
      const res = await getMaterialDetail(row.id);
      currentId.value = res;
      addGmVisible.value = true;
    };
    // 关闭dialog清除数据
    const clearCurrentIdData = () => {
      currentId.value = null;
    };
    // 删除appid
    const _deleteMaterial = row => {
      ElMessageBox.confirm('是否删除该素材', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteMaterial(row.id);
        await loadData();
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      });
    };
    const router = useRouter();
    const handleMaterialDetail = row => {
      router.push(`/operation/material/${row.id}`);
    };
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_row = _resolveComponent("el-row");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 12
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(MaterialCategory, {
            onChangeCategory: handleChangeCategory
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 18
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            class: "padding-0",
            shadow: "never"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: onAddMaterial,
              size: "default"
            }, {
              default: _withCtx(() => [_createTextVNode(" 新增 ")]),
              _: 1
            })]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: data.value,
              style: {
                "width": "100%",
                "height": "600px"
              },
              border: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "title",
                label: "标题"
              }), _createVNode(_component_el_table_column, {
                prop: "cover",
                label: "封面图"
              }, {
                default: _withCtx(({
                  row
                }) => [_createVNode(_component_el_image, {
                  src: row.cover,
                  alt: "string",
                  style: {
                    "width": "70px",
                    "height": "70px"
                  },
                  "preview-src-list": [row.cover],
                  "preview-teleported": true
                }, null, 8, ["src", "preview-src-list"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "createTime",
                label: "创建时间"
              }), _createVNode(_component_el_table_column, {
                label: "操作"
              }, {
                default: _withCtx(({
                  row
                }) => [_createVNode(_component_el_button, {
                  type: "success",
                  size: "small",
                  onClick: $event => handleMaterialDetail(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 详情 ")]),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: $event => editMaterial(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 修改 ")]),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: $event => _deleteMaterial(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 删除 ")]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data"])), [[_directive_loading, loading.value]]), data.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_pagination, {
              onCurrentChange: handleCurrentChange,
              "current-page": currentPage.value,
              "page-size": pageSize,
              total: total.value,
              layout: "total,  prev, pager, next, jumper",
              size: "mini"
            }, null, 8, ["current-page", "total"])])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(MaterialDialog, {
        modelValue: addGmVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => addGmVisible.value = $event),
        model: currentId.value,
        onRefreshData: loadData,
        onClearModel: clearCurrentIdData
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};